import ModuleBreadCrumb from "../../../components/breadCrumb";
import ModuleTitle from "../../../components/common/title";
import MemberQa from "./qa";
import MemberContract from "./contract";

export default function MemberQaMain() {
  const crumbItem = [
    { key: 1, label: "首頁", href: "/member" },
    { key: 3, label: "常見問題" },
  ];

  return (
    <>
      <ModuleBreadCrumb crumbItem={crumbItem} />

      <ModuleTitle data={{ title: "常見問題" }} />

      <MemberQa />

      <MemberContract />
    </>
  );
}
